export enum Translations {
  "FIP.COMMON.ALL_RIGHTS_RESERVED" = "FIP.COMMON.ALL_RIGHTS_RESERVED",
  "FIP.COMMON.MANUFACTURER" = "FIP.COMMON.MANUFACTURER",
  "FIP.COMMON.LOCATION" = "FIP.COMMON.LOCATION",
  "FIP.BRAND.STEP.SCANNED_BY" = "FIP.BRAND.STEP.SCANNED_BY",
  "FIP.COMMON.DATE_TIME" = "FIP.COMMON.DATE_TIME",
  "FIP.COMMON.SHOW_LESS" = "FIP.COMMON.SHOW_LESS",
  "FIP.COMMON.SHOW_MORE" = "FIP.COMMON.SHOW_MORE",
  "FIP.BRAND.STEP.TABLE.NAME" = "FIP.BRAND.STEP.TABLE.NAME",
  "FIP.BRAND.ORDER.TABLE.FILES" = "FIP.BRAND.ORDER.TABLE.FILES",
  "FIP.BRAND.STEP.TABLE.VALIDITY" = "FIP.BRAND.STEP.TABLE.VALIDITY",
  "FIP.BRAND.STEP.TABLE.FIELD" = "FIP.BRAND.STEP.TABLE.FIELD",
  "FIP.BRAND.STEP.TABLE.DOCUMENT" = "FIP.BRAND.STEP.TABLE.DOCUMENT",
  "FIP.COMMON.CERTIFICATES" = "FIP.COMMON.CERTIFICATES",
  "B2C.VERIFY.FAILED" = "B2C.VERIFY.FAILED",
  "B2C.VERIFY_DESC.FAILED" = "B2C.VERIFY_DESC.FAILED",
  "B2C.VERIFY.WARNING" = "B2C.VERIFY.WARNING",
  "B2C.VERIFY_DESC.WARNING" = "B2C.VERIFY_DESC.WARNING",
  "B2C.VERIFY.VERIFIED" = "B2C.VERIFY.VERIFIED",
  "B2C.VERIFICATION.FAILED" = "B2C.VERIFICATION.FAILED",
  "B2C.VERIFICATION.WARNING" = "B2C.VERIFICATION.WARNING",
  "B2C.VERIFICATION_DESC.FAILED" = "B2C.VERIFICATION_DESC.FAILED",
  "B2C.VERIFICATION_DESC.WARNING" = "B2C.VERIFICATION_DESC.WARNING",
  "B2C.TITLE.ECO_SCORE" = "B2C.TITLE.ECO_SCORE",
  "B2C.TITLE.ECO_SCORE_DETAIL" = "B2C.TITLE.ECO_SCORE_DETAIL",
  "B2C.TITLE.PRODUCT_JOURNEY" = "B2C.TITLE.PRODUCT_JOURNEY",
  "B2C.COMMON.BEST" = "B2C.COMMON.BEST",
  "B2C.COMMON.WORST" = "B2C.COMMON.WORST",
  "B2C.COMMON.SHOW_MORE" = "B2C.COMMON.SHOW_MORE",
  "B2C.COMMON.PENDING_REVIEW" = "B2C.COMMON.PENDING_REVIEW",
  "B2C.TAB.MAP_VIEW" = "B2C.TAB.MAP_VIEW",
  "B2C.TAB.DETAILED_VIEW" = "B2C.TAB.DETAILED_VIEW",
  "B2C.NAV.PRODUCT_VERIFICATION" = "B2C.NAV.PRODUCT_VERIFICATION",
  "B2C.NAV.ECO_SCORE" = "B2C.NAV.ECO_SCORE",
  "B2C.NAV.PRODUCT_JOURNEY" = "B2C.NAV.PRODUCT_JOURNEY",
  "FIP.BRAND.ORDER.CO2_EMISSION" = "FIP.BRAND.ORDER.CO2_EMISSION",
  "FIP.COMMON.PRODUCED" = "FIP.COMMON.PRODUCED",
  "FIP.COMMON.REDUCED" = "FIP.COMMON.REDUCED",
  "FIP.BRAND.ORDER.ENERGY_USED" = "FIP.BRAND.ORDER.ENERGY_USED",
  "FIP.COMMON.WASTED" = "FIP.COMMON.WASTED",
  "FIP.COMMON.SAVED" = "FIP.COMMON.SAVED",
  "FIP.BRAND.ORDER.WATER_USED" = "FIP.BRAND.ORDER.WATER_USED",
  "LABEL.SHOW_LESS" = "LABEL.SHOW_LESS",
  "LABEL.SHOW_MORE" = "LABEL.SHOW_MORE",
  
};
